export const TOKEN_FUNCTION = "TOKENFUNCTION";
export const USERINFO = "USERINFO";
export const NAV_BAR = "NAVBAR";
export const OPENMODAL = "OPENMODAL";
export const CLOSEMODAL = "CLOSEMODAL";
export const LOADER = "LOADER"
